import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/(app)/_auth/settings/communication/booking",
)({
  loader: () => ({
    crumb: "alfred.settings.nav.communicationBooking.label",
  }),
})
